module.exports = __webpack_public_path__ + "img/img_applicable_05.c3a7d9bd.png";